import { PrimaryTextColor, boldFont, getRelativeFontSize, primaryLightGray, regularFont } from "../../../../utils/styles";

const OnBoadingSelectIndustryStyles = {
  onBoadingSelectIndustryWrapper: {},
  leftSection: {
    height: "100vh",
    display: "flex",
    alignItems: "start",
    justifyContent: "start",
    flexDirection: "column",
    gap  :"20px",
    paddingTop  :"20vh"
  },
  onboadingHeading :  {
   color : PrimaryTextColor,
   ...boldFont,
   fontSize : getRelativeFontSize(22),
  },
  onBoadingtext : {
  color : primaryLightGray,
  ...regularFont,
  fontSize : getRelativeFontSize(2),
  },

  rightSection: {
    height: "100vh",
    display: "flex",
    alignItems: "start",
    justifyContent: "start",
    flexDirection: "column",
    paddingTop  :"20vh"
  },
};
export default OnBoadingSelectIndustryStyles;
